import React, { createContext, useContext, useEffect, useState } from 'react';
import { api } from '../api';
import { products as mockProducts } from '../data/products';

const ProductsContext = createContext({ products: mockProducts, loading: false, source: 'mock' });

/**
 * Loads the catalogue from the backend and falls back to the bundled mock data
 * if the API isn't reachable yet — so the storefront always renders, and goes
 * fully dynamic the moment the backend is running.
 */
export function ProductsProvider({ children }) {
  const [products, setProducts] = useState(mockProducts);
  const [loading, setLoading] = useState(true);
  const [source, setSource] = useState('mock');

  useEffect(() => {
    let alive = true;
    api
      .getProducts('limit=500')
      .then((res) => {
        const items = res?.items || res?.products;
        if (alive && Array.isArray(items) && items.length) {
          // Normalise Mongo _id → id so existing pages keep working.
          setProducts(items.map((p) => ({ ...p, id: p.id ?? p._id })));
          setSource('api');
        }
      })
      .catch(() => {
        /* keep mock */
      })
      .finally(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
  }, []);

  return (
    <ProductsContext.Provider value={{ products, loading, source }}>
      {children}
    </ProductsContext.Provider>
  );
}

export const useProducts = () => useContext(ProductsContext);
